export default __webpack_public_path__ + "static/media/yellow-korner.aca20290.svg";